import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSelector } from 'react-redux';
import { getFileUrl } from '../../../utils/helper';
import { Link } from 'react-router-dom';
import { ABOUT_ROUTE } from '../../../routes/web/rootRoutes';

function HeroSlider() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAutoPlay, setIsAutoPlay] = useState(true);
    
   const slides = useSelector((state) => state?.globalState?.siteSetting?.slider);

    useEffect(() => {
        if (isAutoPlay) {
            const interval = setInterval(() => {
                setCurrentSlide((prev) => (prev + 1) % slides.length);
            }, 2000);
            return () => clearInterval(interval);
        }
    }, [isAutoPlay, slides.length]);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setIsAutoPlay(false);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
        setIsAutoPlay(false);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
        setIsAutoPlay(false);
    };

    return (
        <div className="w-full bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 py-12 px-4 md:px-8 lg:px-16">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
                    {/* Text Column - Fixed */}
                    <div className="space-y-4 md:space-y-6">
                      

                        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
                            Association of Cine & Television Art Directors & Costume Designers
                        </h1>

                        <p className="text-base md:text-lg text-gray-300 leading-relaxed">
                            Join our community of talented costume designers shaping the visual narrative of Indian cinema. Discover opportunities, connect with peers, and showcase your creativity.
                        </p>

                       
                    </div>

                    <div className="relative">
                        <div className="relative aspect-square md:aspect-[4/3] overflow-hidden rounded-2xl">
                            {slides.map((slide, index) => (
                                <div
                                    key={slide.id}
                                    className={`absolute inset-0 transition-opacity duration-700 ${
                                        index === currentSlide ? 'opacity-100' : 'opacity-0'
                                    }`}
                                >
                                    <div className="relative w-full h-full">
                                        <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-yellow-500 rounded-2xl blur-2xl opacity-20"></div>
                                        <img
                                             src={getFileUrl(slide?.image,'sliders')}
                                            alt={`Slide ${index + 1}`}
                                            className="relative w-full h-full object-cover rounded-2xl shadow-2xl"
                                        />
                                    </div>
                                </div>
                            ))}

                            <button
                                onClick={prevSlide}
                                className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/10 backdrop-blur-md hover:bg-white/20 text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                                aria-label="Previous slide"
                            >
                                <ChevronLeft size={20} />
                            </button>

                            <button
                                onClick={nextSlide}
                                className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/10 backdrop-blur-md hover:bg-white/20 text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                                aria-label="Next slide"
                            >
                                <ChevronRight size={20} />
                            </button>

                            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 flex gap-2">
                                {slides.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => goToSlide(index)}
                                        className={`h-2 rounded-full transition-all duration-300 ${
                                            index === currentSlide
                                                ? 'w-8 bg-gradient-to-r from-red-500 to-yellow-500'
                                                : 'w-2 bg-white/50 hover:bg-white/75'
                                        }`}
                                        aria-label={`Go to slide ${index + 1}`}
                                    />
                                ))}
                            </div>

                            <div className="absolute top-4 right-4 z-10 text-white font-semibold bg-black/30 backdrop-blur-sm px-3 py-1 rounded-full">
                                <span className="text-lg">{String(currentSlide + 1).padStart(2, '0')}</span>
                                <span className="text-white/70 text-sm"> / {String(slides.length).padStart(2, '0')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeroSlider;